import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[appMoneyFormat]'
})
export class MoneyFormatDirective {
    private el: HTMLInputElement;

    constructor(private elementRef: ElementRef) {
        this.el = this.elementRef.nativeElement;
    }

    @HostListener('input', ['$event.target.value'])
    onInput(value: string) {
        const numericValue = value.replace(/[^\d]/g, '');
        this.el.value = this.formatCurrency(numericValue);
    }

    @HostListener('blur')
    onBlur() {
        // Không cần làm gì thêm vì Đ đã được thêm trong onInput
    }

    @HostListener('focus')
    onFocus() {
        this.el.value = this.el.value.replace(/[^\d]/g, '');
    }

    private formatCurrency(value: string): string {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
}
